import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { ProjectHighlightElement } from '../../../dynamic-layout-parser/types/dynamic-layout-section';

interface ProjectHightlightCardComponentProps {
	component: ProjectHighlightElement;
}

const styles = cssMap({
	container: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderRadius: token('radius.large'),
	},
	summaryBox: {
		maxWidth: '220px',
	},
});

export const DynamicLayoutProjectHighlightCard = ({
	component,
}: ProjectHightlightCardComponentProps): React.JSX.Element | null => {
	const title = component?.attributes?.title || '';
	const text = component?.attributes?.content || '';

	return title || text ? (
		<Inline xcss={cx(styles.container)} space="space.200" alignBlock="center">
			<Stack space="space.050">
				{title && (
					<Text weight="bold" size="small" maxLines={1}>
						{title.toLocaleUpperCase()}
					</Text>
				)}
				{text && (
					<Box xcss={styles.summaryBox}>
						<Text color="color.text.subtle" maxLines={1}>
							{text}
						</Text>
					</Box>
				)}
			</Stack>
		</Inline>
	) : null;
};
